/**
 * Shared property sync utility for eInvoice module.
 * Ensures bidirectional sync between page-level and global (header) property selectors.
 */

/**
 * Read the current global property ID from localStorage.
 * Returns the property ID string, or null for "All Properties".
 */
export function getGlobalPropertyId() {
  return localStorage.getItem('einvoice_selected_property') || null;
}

/**
 * Update the global property selection and notify all listeners (including PortalLayout header).
 * Call this when a page-level property dropdown changes.
 * @param {string|null} propertyId - The property ID, or null/"all" for All Properties
 * @param {Array} properties - Full properties list to resolve the property object
 */
export function setGlobalProperty(propertyId, properties = []) {
  const isAll = !propertyId || propertyId === 'all';
  if (isAll) {
    localStorage.removeItem('einvoice_selected_property');
    window.dispatchEvent(new CustomEvent('property-changed', { detail: null }));
  } else {
    localStorage.setItem('einvoice_selected_property', propertyId);
    const prop = properties.find(p => p.id === propertyId) || { id: propertyId };
    window.dispatchEvent(new CustomEvent('property-changed', { detail: prop }));
  }
}
